export function throttle<Args extends any[]>(fn: (...args: Args) => any, interval: number) {
	let timeoutId = 0;

	let savedArgs: Args | undefined;

	function throttleTrigger(...args: Args) {
		savedArgs = args;

		if (!timeoutId) {
			timeoutId = window.setTimeout(() => {
				fn(...savedArgs!);
				timeoutId = 0;
			}, interval);
		}
	}

	throttleTrigger.cancel = () => {
		savedArgs = undefined;
		clearTimeout(timeoutId);
	};

	throttleTrigger.pending = () => {
		return timeoutId === 0;
	};

	return throttleTrigger;
}
